/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './gateway-group.scss';

/* eslint-disable import/no-unresolved, import/default */

import gatewayGroupFieldsetTemplate from './gateway-group-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GatewayGroupDirective($compile, $templateCache, $translate, $mdUtil, $filter, types, gatewayService, gatewayGroupService, fskLocationService, userService, importExport, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(gatewayGroupFieldsetTemplate);
        element.html(template);
        scope.types = types;

        scope.fskLocations = [];
        scope.fskSelection = { id: null };
        // FSK Locations belong to the Neptune customer only. The backend returns them only to Neptune
        // customer users (others get 403), so a successful load doubles as "this user may use FSK
        // Locations" — the dropdown is shown only then (see fsk-location gating in the template).
        scope.fskAccess = false;

        function loadFskLocations() {
            var currentUser = userService.getCurrentUser();
            if (!currentUser || !currentUser.customerId) {
                scope.fskAccess = false;
                return;
            }
            fskLocationService.getFskLocations().then(
                (locations) => { scope.fskLocations = locations || []; scope.fskAccess = true; },
                () => { scope.fskLocations = []; scope.fskAccess = false; }
            );
        }

        function initSelectedFskLocation() {
            scope.fskSelection.id = (scope.gatewayGroup && scope.gatewayGroup.fskLocationId)
                ? scope.gatewayGroup.fskLocationId.id : null;
        }

        scope.onFskLocationChange = function() {
            scope.gatewayGroup.fskLocationId = scope.fskSelection.id
                ? { entityType: 'FSK_LOCATION', id: scope.fskSelection.id }
                : null;
        };

        scope.$watch('gatewayGroup.id.id', () => { initSelectedFskLocation(); });

        loadFskLocations();

        scope.onGatewayGroupIdCopied = function() {
            toast.showSuccess($translate.instant('gateway-group.idCopiedMessage'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (newVal && !angular.equals(newVal, prevVal)) {
                scope.selectedTab = 0;
            }
        });

        scope.onGatewayGroupTabSelected = function(eventName) {
            scope.$broadcast(types.broadcastEvents.GATEWAY_GROUP[eventName]);
        }

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            gatewayGroup: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/gateway-group/gateway-group.directive.js